import React from 'react';
import { useObserverForResize } from '@hooks/useObserverForResize';
import { ChipBar, StyledChip } from '../MultiSearchSelect.styles';

interface SelectedChipBarProps {
  selectedOptions: { label: string; value: number }[];
  remove: (val: number) => void;
  displayCount: number;
  disabled: boolean;
}

const SCREEN_SMALL = 1366;
const SCREEN_MEDIUM = 1920;
const SCREEN_LARGE = 2560;

const getDisplayCount = (width: number): number => {
  if (width < SCREEN_SMALL) return 0;
  if (width < SCREEN_MEDIUM) return 1;
  if (width < SCREEN_LARGE) return 2;
  return 3;
};

function SelectedChipBar({
  selectedOptions,
  remove,
  displayCount: forceDisplayCount,
  disabled = false
}: SelectedChipBarProps) {
  const { width } = useObserverForResize(1000);
  const displayCount = forceDisplayCount || getDisplayCount(width);
  const additionalCount = selectedOptions.length - displayCount;

  return (
    <ChipBar item xs={12}>
      {selectedOptions.length > 0 &&
        selectedOptions
          .filter((_, i) => i < displayCount)
          .map(({ label: lab, value: val }) => (
            <StyledChip
              key={val}
              label={lab.length > 16 ? `${lab.substring(0, 16)}...` : lab}
              {...(!disabled && { onDelete: () => remove(val) })}
            />
          ))}
      {additionalCount > 0 && <StyledChip label={`+ ${additionalCount} selected`} />}
    </ChipBar>
  );
}

export default SelectedChipBar;
